import React, { PropsWithChildren } from "react";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { useLanguageContext } from "../language-context/LanguageContext.ts";
import { locales } from "./LocalizationDateContextProvider.utils.ts";

const LocalizationDateProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { language } = useLanguageContext();
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locales[language]}>
      {children}
    </LocalizationProvider>
  );
};

export default LocalizationDateProvider;
